module.exports = __webpack_public_path__ + "img/part.645c3bb6.png";